import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BelarusFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14379'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14379)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33333H20V0H0V9.33333Z'
					fill='#E54252'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#5CBE6B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0H2.85714V2.1L2.38095 2.8L2.85714 3.5V4.9L2.38095 5.6L2.85714 6.3V7.7L2.38095 8.4L2.85714 9.1V10.5L2.38095 11.2L2.85714 11.9V14H0V0Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.475353 1.40002L-1.42773 2.80002L-0.475353 4.20002L-1.42773 5.60002L-0.475353 7.00002L-1.42773 8.40002L-0.475353 9.80002L0.477028 8.40002L-0.475353 7.00002L0.477028 5.60002L-0.475353 4.20002L0.477028 2.80002L-0.475353 1.40002ZM-0.475353 9.80002L-1.42773 11.2L-0.475353 12.6L0.477028 11.2L-0.475353 9.80002Z'
					fill='#E54252'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0.476562 1.4L1.42894 0L2.38132 1.4L1.42894 2.8L0.476562 1.4ZM1.42894 5.6L0.476562 4.2L1.42894 2.8L2.38132 4.2L1.42894 5.6ZM1.42894 8.4L0.476562 7L1.42894 5.6L2.38132 7L1.42894 8.4ZM1.42894 11.2L2.38132 9.8L1.42894 8.4L0.476562 9.8L1.42894 11.2ZM1.42894 11.2L2.38132 12.6L1.42894 14L0.476562 12.6L1.42894 11.2Z'
					fill='#E54252'
				/>
			</g>
		</svg>
	);
};

export default BelarusFlagIcon;
